<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 64px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 64px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" v-if="formAction === 'add'">
          <v-list-item-icon>
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-title>เพิ่มหน่วยงานใหม่</v-list-item-title>
        </v-list-item>
        <v-list-item class="px-0" two-line v-else>
          <v-list-item-content>
            <v-list-item-title>
              {{ organizationInit.organization_code }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ organizationInit.title_th }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          รหัสหน่วยงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="organization.organization_code"
          :rules="[
            (v) => !!v || 'โปรดระบุรหัสหน่วยงาน',
            (v) =>
              (v && v.length >= 1 && v.length <= 32) ||
              'รหัสหน่วยงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'organization_code')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ชื่อหน่วยงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="organization.title_th"
          :rules="[
            (v) => !!v || 'โปรดระบุชื่อหน่วยงาน',
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อหน่วยงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> ชื่อหน่วยงาน (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="organization.title_en"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 100) ||
              'ชื่อหน่วยงานต้องน้อยกว่า 100 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2"> คำอธิบาย </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="4"
          v-model="organization.description"
          :rules="[
            (v) =>
              !v ||
              (v && v.length <= 1000) ||
              'คำอธิบายต้องน้อยกว่า 1000 ตัวอักษร',
          ]"
          clearable
          @change="checkEmpty($event, 'description')"
          outlined
          dense
        ></v-text-field>
        <div>
          <label class="body-2"> หัวหน้า </label>
          <v-text-field
            class="fix-google-chrome mt-1"
            readonly
            :value="
              organization.organizationBoss
                ? organization.organizationBoss.fullname
                : ''
            "
            outlined
            dense
          >
            <template v-slot:append>
              <v-btn
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::organization:boss:delete')
                "
                class="mb-2"
                icon
                v-if="organization.organizationBoss"
                @click="handleDeleteOrganizationBoss"
              >
                <v-icon>mdi-delete </v-icon>
              </v-btn>
              <v-btn
                :disabled="
                  uiCtrl && !uiCtrl.isEnable('btn:::organization:boss:update')
                "
                class="mb-2"
                icon
                v-else
                @click="addOrganizationBoss"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </div>
        <label class="body-2">
          สังกัดหน่วยงาน
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-autocomplete
          class="fix-google-chrome mt-1"
          v-if="
            organizationInit.root_organization_uuid !== null &&
            organizationsAll.length !== 0
          "
          tabindex="5"
          v-model="organization.root_organization_uuid"
          :items="
            organizationsAll
              .filter(
                (filterOrg) =>
                  filterOrg.organization_uuid !== organization.organization_uuid
              )
              .sort((a, b) =>
                a.organization_code.localeCompare(b.organization_code)
              )
              .map((org) => ({
                text: `${org.organization_code} : ${org.title_th}`,
                ...org,
              }))
          "
          :rules="[(v) => !!v || 'โปรดระบุหน่วยงาน']"
          item-text="text"
          item-value="organization_uuid"
          outlined
          dense
        >
        </v-autocomplete>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row
          justify="center"
          align="center"
          v-if="!isOrganizationDataChange && formAction === 'edit'"
        >
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::organization:delete')"
            icon
            @click="onDelete"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center" align="center" v-else>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::organization:create')"
            tabindex="6"
            class="primary mr-3"
            depressed
            v-if="formAction === 'add'"
            @click="onSubmit"
            >ตกลง
          </v-btn>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::organization:update')"
            tabindex="6"
            class="primary mr-3"
            depressed
            v-else
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDelete"
      :loading="confirmDialogDeleteLoading"
      :dialogData="confirmDialogDeleteData"
      @cancelConfirmDialog="cancelConfirmDialogDelete"
      @submitConfirmDialog="submitConfirmDialogDelete"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <EmployeeListDialog
      :dialog="employeeListDialog"
      @cancelEmployeeListDialog="cancelEmployeeListDialog"
      @submitEmployeeListDialog="submitEmployeeListDialog"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeListDialog from '@/components/EmployeeListDialog.vue'

export default {
  components: {
    ConfirmDialog,
    EmployeeListDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    formAction: {
      type: String,
      default: '',
    },
    organization: {
      type: Object,
    },
    organizationInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogForbidden: false,
      confirmDialogDelete: false,
      confirmDialogDeleteLoading: false,
      confirmDialogDeleteData: {},
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      employeeListDialog: false,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    isOrganizationDataChange() {
      if (
        this.organization.organization_code !==
          this.organizationInit.organization_code ||
        this.organization.title_th !== this.organizationInit.title_th ||
        this.organization.title_en !== this.organizationInit.title_en ||
        this.organization.description !== this.organizationInit.description ||
        this.organization.organizationBoss !==
          this.organizationInit.organizationBoss ||
        this.organization.root_organization_uuid !==
          this.organizationInit.root_organization_uuid
      ) {
        this.$emit('isOrganizationDataChange', true)
        return true
      }
      this.$emit('isOrganizationDataChange', false)
      return false
    },
    organizationsAll() {
      return this.$store.state.organization.organizationsAll
    },
  },
  methods: {
    ...mapActions({
      addOrganization: 'organization/addOrganization',
      editOrganization: 'organization/editOrganization',
      deleteOrganization: 'organization/deleteOrganization',
      editOrganizationBoss: 'organization/editOrganizationBoss',
      deleteOrganizationBoss: 'organization/deleteOrganizationBoss',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.organization[field] = value.trim()
      }
    },
    onDelete() {
      this.confirmDialogDelete = true
      this.confirmDialogDeleteData = {
        title: 'ยืนยันการลบ',
        text: 'คุณต้องการลบหน่วยงาน',
        value: `${this.organization.organization_code} : ${this.organization.title_th}`,
        item: this.organization,
      }
    },
    cancelConfirmDialogDelete() {
      this.confirmDialogDelete = false
    },
    async submitConfirmDialogDelete(organization) {
      try {
        this.confirmDialogDeleteLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        await this.deleteOrganization({
          company_uuid,
          organization_uuid: organization.organization_uuid,
        })

        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)

        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      } catch (error) {
        this.confirmDialogDeleteLoading = false
        this.confirmDialogDelete = false

        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleDeleteOrganizationBoss() {
      this.organization.organizationBoss = null
    },
    addOrganizationBoss() {
      this.employeeListDialog = true
    },
    cancelEmployeeListDialog() {
      this.employeeListDialog = false
    },
    submitEmployeeListDialog(selectedItems) {
      const boss = {
        employee_uuid: selectedItems[0].employee_uuid,
        firstname_th: selectedItems[0].firstname_th,
        lastname_th: selectedItems[0].lastname_th,
      }

      const organizationBoss = {
        employee_uuid: boss.employee_uuid,
        fullname: `${boss.firstname_th} ${boss.lastname_th}`,
      }
      this.organization.organizationBoss = organizationBoss

      this.employeeListDialog = false
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        try {
          this.$store.state.loading = true

          if (!this.organization.title_en) {
            this.organization.title_en = null
          }

          if (!this.organization.description) {
            this.organization.description = null
          }

          const { company_uuid } = this.$store.state.authentication.company

          const { organization_uuid } = await this.addOrganization({
            company_uuid,
            organization: this.organization,
          })

          if (
            this.organization.organizationBoss &&
            this.uiCtrl &&
            this.uiCtrl.isEnable('btn:::organization:boss:update')
          ) {
            await this.editOrganizationBoss({
              company_uuid,
              organization_uuid,
              employee_uuid: this.organization.organizationBoss.employee_uuid,
            })

            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          } else {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          }
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async onSave() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        if (
          this.uiCtrl &&
          !this.uiCtrl.isEnable('btn:::organization:boss:update')
        ) {
          try {
            await this.editOrganization({
              company_uuid,
              organization: this.organization,
            })

            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          } catch (error) {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        } else if (this.organization.organizationBoss) {
          try {
            await this.editOrganizationBoss({
              company_uuid,
              organization_uuid: this.organization.organization_uuid,
              employee_uuid: this.organization.organizationBoss.employee_uuid,
            })

            await this.editOrganization({
              company_uuid,
              organization: this.organization,
            })

            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          } catch (error) {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        } else {
          try {
            await this.deleteOrganizationBoss({
              company_uuid,
              organization_uuid: this.organization.organization_uuid,
            })

            await this.editOrganization({
              company_uuid,
              organization: this.organization,
            })

            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$emit('formActionCompleted', this.formAction)
            this.$refs.form.reset()
          } catch (error) {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        }
      }
    },
    onClose() {
      if (this.isOrganizationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('formActionCompleted', this.formAction)
        this.$refs.form.reset()
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$emit('formActionCompleted', this.formAction)
      this.$refs.form.reset()
    },
    onReset() {
      if (this.formAction === 'add' || this.formAction === '') {
        this.organization.organizationBoss = null
        this.$refs.form.reset()
      } else {
        this.$emit('onReset', this.formAction)
      }
    },
  },
}
</script>
